export const BETA_NOTICE_STORAGE_KEY = "scamatrix-beta-notice";
export const WEBIOC_NOTICE_STORAGE_KEY = "scamatrix-webioc-notice";
